/*
* Generate bid letter from template for an order
*/

import * as _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import scrollToComponent from 'react-scroll-to-component';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import Branding from '../../branding/branding';
import * as AppComp from '../../common/app-component-base';
import * as AppUtilities from '../../common/apputilities';
import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../../common/formatters';
import ApiEndpoints from '../../config/apiendpoints';
import { AppImages } from '../../config/images';
import * as ReduxQueries from '../../queries';

import { Render as ReportPageContract } from './pages/report-page-contract';
import { Render as ReportPageCover } from './pages/report-page-cover';
import { Render as ReportPageResumes } from './pages/report-page-resumes';
import { Render as ReportPageSelectedProjects } from './pages/report-page-selected-projects';

import '../../branding/report-pdf.css';
import './order-bid-letter-pdf.css';

export interface IOrderBidLetterMultiplePdfProps extends AppComp.IAppComponentProps {
    orderObjIds?: any;
    orderDetailOrders?: any;
    associations?: any;
    clients?: any;
    offices?: any;
    serviceLevels?: any;
    orderManagerUsers?: any;
    navigateTo?: any;
    bidLetterTextContents?: any;
}

export interface IOrderBidLetterMultiplePdfState extends AppComp.IAppComponentState {
    formChanges?: any;
    reportPageCount: number;
}

class OrderBidLetterMultiplePdf extends AppComp.AppComponent<IOrderBidLetterMultiplePdfProps, IOrderBidLetterMultiplePdfState> {
    // public originalExtendedInventoryCache: Array<any> = [];
    public sectionPages: Array<any> = [];
    public originalFormDataCache = {};
    public pdfExportComponent: any = undefined;

    public constructor(props: any) {
        super(props, 'app.report-association.');

        this.state = {
            formChanges: {},
            reportPageCount: 0,
        };
    }

    // TRANSFORMS
    public extendOrder(order: any) {
        if (!order) { return {}; }

        let record = _.cloneDeep(order);

        record.orderClientContactLetter = Formatters.composeClientContactLetter(_.get(record, 'contact'));
        record.orderClientContactLetterSaluatation = Formatters.composeClientContactLetter(_.get(record, 'contact'), false);
        record.orderClientAddressCityStateZip = Formatters.composeLocationCityStateZipCountry(_.get(record, 'association.client.location'), false);

        return record;
    }

    public extendAssociationData(record: any) {
        if (!record) { return; }

        let result = _.cloneDeep(record);
        const invSubgroups = AppUtilities.getArray(record, 'inventorySubgroups');
        if (AppUtilities.isArrayWithLength(invSubgroups)) {
            result.inventorySubgroups = result.inventorySubgroups.map(c => {
                if (!c.label) {
                    c.label = Formatters.composeInventorySubgroupLabel(c, true); // c.label = `${c.groupCode} - ${c.title}`;
                }

                return c;
            });
        }

        return result;
    }

    // HELPERS
    public getFormData(orderIn: any, orderId: any, services: any, associationClient: any, orderClient: any) {
        const order = _.merge(orderIn, this.state.formChanges);

        let result = {
            association: _.get(order, 'association'),
            associationId: Formatters.getInt(order, 'associationId'),

            client: _.get(order, 'client'),
            clientId: Formatters.getInt(order, 'clientId'),

            orderId: orderId,

            // orderDashNumber: _.get(order, 'orderId') + '-' + Formatters.getOrderDashLetter(order),
            orderDashNumber: _.get(order, 'orderId') + '-' + Formatters.getInt(order, 'dash'),

            user: _.get(order, 'user'),
            siteInspector: _.get(order, 'siteInspector'),

            bidDate: _.get(order, 'bidDate'),
            bidSentDate: _.get(order, 'bidSentDate'),
            completionDate: _.get(order, 'completionDate'),
            dueDate: _.get(order, 'dueDate'),
            followUpDate: _.get(order, 'followUpDate'),
            preparedForFYEDate: _.get(order, 'preparedForFYEDate'),
            reminderBidDate: _.get(order, 'reminderBidDate'),
            siDueDate: _.get(order, 'siDueDate'),
            startDate: _.get(order, 'startDate'),
            wonDate: _.get(order, 'wonDate'),

            feedback: _.get(order, 'feedback'),
            sampleSent: _.get(order, 'sampleSent'),
            unsolicitedBid: _.get(order, 'unsolicitedBid'),
            contractReceived: _.get(order, 'contractReceived'),
            enteredInQuickbooks: _.get(order, 'enteredInQuickbooks'),
            invoiceSentInQuickbooks: _.get(order, 'invoiceSentInQuickbooks'),

            acceptedPrice: Formatters.getFloat(order, 'acceptedPrice'),
            status: _.get(order, 'status'),
            serviceLevel: _.get(order, 'serviceLevel'),
            serviceLevelId: Formatters.getInt(order, 'serviceLevelId'),

            contact: _.get(order, 'contact'),
            contactId: Formatters.getInt(order, 'contactId'),

            pricingMatrix: _.get(order, 'pricingMatrix'),
            orderServicesPricingMatrix: _.get(order, 'orderServicesPricingMatrix', {}),

            orderNotesAdd: Formatters.getStr(order, 'orderNotesAdd'),
            orderNotesDelete: _.get(order, 'orderNotesDelete', []),
            orderNotes: _.get(order, 'notes', []),

            followUpNotesAdd: Formatters.getStr(order, 'followUpNotesAdd'),
            followUpNotesDelete: _.get(order, 'followUpNotesDelete', []),
            followUpNotes: _.get(order, 'followUpNotes', []),

            setDueDateWeeks: _.get(order, 'setDueDateWeeks', 1),
            newDueDate: new Date(),
        };

        _.set(result, 'newDueDate', moment(result.startDate).add(result.setDueDateWeeks, 'week').toDate());

        // Order notes
        if (_.size(result.orderNotes)) {
            result.orderNotes = _.filter(result.orderNotes, (o) => Formatters.getStr(o, 'notes') !== '');
            if (_.size(result.orderNotes)) {
                result.orderNotes = _.orderBy(result.orderNotes, ['created'], ['desc']);
            }
        }

        if (_.size(result.orderNotesDelete)) {
            result.orderNotes = _.omitBy(result.orderNotes, (o) => _.includes(result.orderNotesDelete, o.objectId));
        }

        // Follow up notes
        if (_.size(result.followUpNotes)) {
            result.followUpNotes = _.filter(result.followUpNotes, (o) => Formatters.getStr(o, 'notes') !== '');
            if (_.size(result.followUpNotes)) {
                result.followUpNotes = _.orderBy(result.followUpNotes, ['created'], ['desc']);
            }
        }

        if (_.size(result.followUpNotesDelete)) {
            result.followUpNotes = _.omitBy(result.followUpNotes, (o) => _.includes(result.followUpNotesDelete, o.objectId));
        }

        return _.merge(result, this.state.formChanges);
    }

    public getFormChangesCount() {
        return _.size(this.state.formChanges);
    }

    public getFormChangesResetRequired() {
        let resetFormData = false;
        // Props values
        const pa = Formatters.getInt(this.props, 'orderId');

        // Cached values
        const ca = Formatters.getInt(this.originalFormDataCache, 'orderId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            resetFormData = (pa !== ca) ? true : false;
        }

        return resetFormData;
    }

    public getIsHypothetical() {
        return false;
        // const isHypothetical = (this.state.inventoryChanges.length === 0 && _.keys(this.state.formChanges).length === 0) ? false : true;

        // return isHypothetical;
    }

    public getCompanyLogoByOrderAssociation(currentOrder: any, location: string = Branding.appBrandLogoLocations.bidLetterFooter) {

        const companyBrandKey = _.get(currentOrder, 'association.company.brandKey', Branding.appBrandKeys.complexSolutions);

        const path = `${companyBrandKey}.logo.${location}`;
        const result = _.get(AppImages, path, '');

        // console.log(`getCompanyLogoByOrderAssociation location ${location} companyBrandKey ${companyBrandKey} result ${result}`, currentOrder);

        return result;
    }

    public getBrandingCssName(order: any) {
        const companyBrandKey = _.get(order, 'association.company.brandKey', Branding.appBrandKeys.complexSolutions);

        return companyBrandKey;
    }

    public registerSectionPageRef = (element: any, sectionName: string, pageIndex: number = 0) => {
        const pageKey = `${sectionName}-${pageIndex}`;

        const existing = _.find(this.sectionPages, ['pageKey', pageKey]);
        if (existing) {
            if (_.get(existing, 'elementRef') !== element) {
                _.set(existing, 'elementRef', element);
            }
        }
    }

    public registerSectionPage = (sectionName: string, pageTitle: string = '', pageIndex: number = 0, includeInPageCount: boolean = true): number => {
        const eligiblePages = _.filter(this.sectionPages, (o) => _.get(o, 'includeInPageCount', true));
        const pageCount = _.size(eligiblePages);

        const pageNumber = (includeInPageCount) ? pageCount + 1 : 0;
        const pageKey = `${sectionName}-${pageIndex}`;

        const existing = _.find(this.sectionPages, ['pageKey', pageKey]);
        if (!existing) {
            const page = {
                elementRef: undefined,
                includeInPageCount: includeInPageCount,
                pageKey: pageKey,
                pageNumber: pageNumber,
                pageTitle: pageTitle,
                sectionName: sectionName,
            };

            this.sectionPages.push(page);

            if (includeInPageCount) {
                this.setState({ reportPageCount: pageCount + 1 });
            }
        } else {
            return existing.pageNumber;
        }

        return pageNumber;
    }

    public getFirstPageOfSection = (secName: string): any => _(this.sectionPages).sortBy('pageNumber').find(['sectionName', secName]);

    public getPageNum = (secName: string) => _.get(this.getFirstPageOfSection(secName), 'pageNumber');

    public getPageRef = (secName: string) => _.get(this.getFirstPageOfSection(secName), 'elementRef');

    public handleScrollTo = (e: any, s: string = '') => {
        if (e) { e.preventDefault(); }

        scrollToComponent(this.getPageRef(s), { align: 'top', ease: 'out-circ', duration: 850, offset: -55 });

        return false;
    }

    // HANDLERS
    public handlePrintPageButton(e: any) {
        window.print();
    }

    public handleViewBidEnvelopeButton(e: any) {
        // const { orderId } = this.props;
        // this.props.navigateTo(NavigationLinks.orderBidEnvelopePdf(orderId));
    }

    public handleViewOrderButton(e: any) {
        // const { orderId } = this.props;
        // this.props.navigateTo(NavigationLinks.orderDetail(orderId));
    }

    // RENDERERS
    public renderHeaderButtonToolbar = () => {
        let buttonProps = {
            bsSize: 'sm',
        };

        return (
            <div className="header-print-buttontoolbar-bid-letter">
                <Well className="header-well-buttontoolbar">
                    <Row>
                        <Col xs={6}>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    <Button {...buttonProps} bsStyle="info" onClick={(e) => { this.handlePrintPageButton(e); }}>
                                        <i className="glyphicon glyphicon-print" /> {this.appTextCommon('buttons.print-document')}
                                    </Button>
                                </ButtonGroup>

                                { /* <ButtonGroup>
                                    <Button {...buttonProps} bsStyle="info" onClick={(e) => { this.handleViewBidEnvelopeButton(e); }}>
                                        <i className="fa fa-file-pdf-o" /> {this.appText('view-bid-envelope')}
                                    </Button>
                                    <Button {...buttonProps} bsStyle="info" onClick={(e) => { this.handleViewOrderButton(e); }}>
                                        <i className="glyphicon glyphicon-eye-open" /> {this.appText('view-order')}
                                    </Button>
                                </ButtonGroup> */ }
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </Well>
            </div>
        );
    }

    public render() {
        const { orderDetailOrders, orderObjIds, associations, serviceLevels, clients, offices, orderManagerUsers, bidLetterTextContents, ...rest } = this.props;

        let page = (<div>{this.appTextCommon('loading-data')}</div>);
        let brandingCssName = '';

        if (orderDetailOrders && _.size(orderDetailOrders)) { // Number(Formatters.getInt(order, 'orderId')) === Number(orderId)) {
            let pages = _.map(orderDetailOrders, (c, cInd) => {
                const order = this.extendOrder(c);
                const orderId = Formatters.getInt(c, 'orderId');

                const associationClient = _.find(clients, { 'clientId': Formatters.getInt(order, 'association.client.clientId') });
                const orderClient = _.find(clients, { 'clientId': Formatters.getInt(order, 'client.clientId') });

                const orderManagerUser = _.find(orderManagerUsers, { '_id': Formatters.getStr(c, 'user.userObjectId') });
                const formData = this.getFormData(order, orderId, serviceLevels, associationClient, orderClient);

                const cloneCurrentOrder = order;
                const isHypothetical = this.getIsHypothetical();
                brandingCssName = this.getBrandingCssName(cloneCurrentOrder);

                if (this.getFormChangesResetRequired() || !_.size(this.originalFormDataCache)) {
                    this.originalFormDataCache = _.cloneDeep(formData);
                }

                // FOOTER DATA
                const reportData = {
                    association: _.get(cloneCurrentOrder, 'association'),
                    associationClient: associationClient,
                    branding: {
                        logoCoverPage: this.getCompanyLogoByOrderAssociation(cloneCurrentOrder, Branding.appBrandLogoLocations.reportCoverPage),
                        logoFooter: this.getCompanyLogoByOrderAssociation(cloneCurrentOrder, Branding.appBrandLogoLocations.reportFooter),
                        bidLetterHeader: this.getCompanyLogoByOrderAssociation(cloneCurrentOrder, Branding.appBrandLogoLocations.bidLetterHeader),
                        bidLetterFooter: this.getCompanyLogoByOrderAssociation(cloneCurrentOrder, Branding.appBrandLogoLocations.bidLetterFooter),
                    },
                    currentOrder: order,
                    orderClient: orderClient,
                    orderManagerUser: orderManagerUser,
                    currentOrderChart: { draft: false },
                    pricingMatrix: _.filter(formData.pricingMatrix, (o) => Formatters.getStr(o, 'level') !== '4'),
                    orderServicesPricingMatrix: _.get(formData, 'orderServicesPricingMatrix', {}),
                    serviceLevels: serviceLevels,
                    formData: formData,
                    isHypothetical: isHypothetical,
                    bidLetterTextContents: bidLetterTextContents,
                };

                // console.log('pageData', {
                //     reportData: reportData,
                //     orderId: orderId,
                //     order: cloneCurrentOrder,
                //     formData: formData,
                //     numChanges: this.getFormChangesCount(),
                // });

                const reportPagesProps = {
                    appText: (e) => this.appText(e),
                    reportData: reportData,
                };

                return (
                    <div key={`pdf-multiple-bid-letter-${orderId}`}>
                        <ReportPageCover reportData={reportData} />
                        <ReportPageContract reportData={reportData} />
                        <ReportPageResumes reportData={reportData} />
                        <ReportPageSelectedProjects reportData={reportData} />
                    </div>
                );
            });

            page = (
                <div>
                    {this.renderHeaderButtonToolbar()}
                    {pages}
                </div>
            );
        }

        return (
            <div className={brandingCssName}>
                <AppComp.RenderPageWithLayout
                    branding={this.props.branding}
                    pageName=""
                    wrapperClassName={`pdf-order-bid-letter-page-layout-container`}
                    {...rest}
                >
                    <div className="center-block pdf-order-bid-letter-pages-container">
                        {page}
                    </div>
                </AppComp.RenderPageWithLayout>
            </div>
        );
    }
}

const getApiUrl = props => ApiEndpoints.getOrdersBidLettersDataUrl(_.get(props, 'match.params.orderObjIds', ''));

const mapPropsToConfigs = (props) => ReduxQueries.Queries.getOrdersDataBidLettersRequest(
    getApiUrl(props),
    ReduxQueries.PropsAccessToken(props),
);

const mapStateToProps = (state, props) => {
    const orderObjIds = _.get(props, 'match.params.orderObjIds', '');

    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
        orderObjIds: orderObjIds,
        orderDetailOrders: state.entities.orderBidLetterPdfOrders,
        associations: state.entities.orderBidLetterPdfAssociations,
        clients: state.entities.orderBidLetterPdfClients,
        offices: state.entities.orderBidLetterPdfOffices,
        serviceLevels: state.entities.orderBidLetterPdfServiceLevels,
        orderManagerUsers: state.entities.orderBidLetterPdfOrderManagerUsers,
        bidLetterTextContents: state.entities.orderBidLetterPdfTextContents,
    });
};

const mapDispatchToProps = {
    navigateTo: (path) => push(path),
};

const OrderBidLetterMultiplePdfContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(OrderBidLetterMultiplePdf);

export default withRouter(OrderBidLetterMultiplePdfContainer);



// WEBPACK FOOTER //
// ./src/order/bid-letter/pdf-multiple.tsx